var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-8 col-md-8 col-lg-4 align-self-center"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-5 text-center"},[_c('h1',{staticStyle:{"font-size":"400%"}},[_vm._v("404")]),_c('p',[_vm._v(_vm._s(_vm.$t('errors_404')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }